import { Pipe, PipeTransform } from '@angular/core';
import { FlowConstants } from '../utils';

@Pipe({
    name: 'visualId'
})
export class VisualIdPipe implements PipeTransform {
    transform(visualId: string | undefined, value: string | number = ''): string | undefined {
        if (!visualId) {
            return undefined;
        }

        return visualId.replace(FlowConstants.VALUE_PLACEHOLDER, `${value}`);
    }
}
